import Icon from 'components/atoms/icon/Icon';
import Accordion from 'components/molecules/accordion/Accordion';
import AccordionBody from 'components/molecules/accordion/AccordionBody/AccordionBody';
import AccordionTitle from 'components/molecules/accordion/AccordionTitle/AccordionTitle';
import { IconType } from 'lib/helpers/constants/iconTypes';
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next';


interface IShowAllDocumentsProps {
    setIsAddingDocument: (value: boolean) => void
    data: any
}

const ShowAllDocuments: FC<IShowAllDocumentsProps> = ({ setIsAddingDocument, data }) => {

    const { t } = useTranslation()

    return (
        <div>

            <Accordion classes={{ wrapper: '!rounded-2xl !p-0 !border-[#A2A1A833] mt-5', title: '!bg-[#F6FBFE] !px-4 !py-3 !rounded-2xl', body: '!px-4 !mt-0' }}>
                <AccordionTitle subTitleClass={'font-inter-semibold text-primaryTextColor'}>{t('Documents List')}</AccordionTitle>
                <AccordionBody>
                    <div className='pb-4 mt-4 w-full space-y-5'>
                        {data?.product_files?.length !== 0 ? (
                            data?.partner_files?.map((file: any, index: number) => (
                                <div className="flex flex-col gap-3" key={index}>
                                    <div className="font-inter-medium text-primaryTextColor text-sm">
                                        &#x2022; {t(file.file)} ({file.required ? t('Required') : t('Optional')})
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="text-[#7D8592] text-xs font-inter-regular">
                                <span>{t("No Files have been added yet")}</span>
                            </div>
                        )}
                    </div>
                </AccordionBody>
            </Accordion>

            <div className='flex justify-end mt-4'>
                <div className='flex items-center gap-2 cursor-pointer' onClick={() => { setIsAddingDocument(true) }}>
                    <Icon iconType={IconType.PLUS_ICON} color='var(--theme)' />
                    <span className='text-sm font-inter-medium text-theme'>{t('Add File')}</span>
                </div>
            </div>

        </div>
    )
}

export default ShowAllDocuments